import React, { ReactElement, MouseEvent, useState, ChangeEvent } from "react"
import { ButtonProps } from "./IconEditButton"
import IconEditButton from "."
import ConfirmDialogue from "../ConfirmDialogue"
import { TextField } from "@material-ui/core"
import { useCustomTitleStyles } from "../CFC/__config/styles"

/**
 * Icon delete button with a confirm dialog component
 *
 * @export
 * @param {ButtonProps} {
 * 	onClick,
 * }
 * @returns {ReactElement}
 */
export default function IconEditButtonwDialog({
	onTitleChange,
	title,
}: any): ReactElement {
	const [dialogOpen, setDialogOpen] = useState<boolean>(false)

	const [cacheTitle, setCacheTitle] = useState<string>(title)

	/**
	 * Closes the dialog
	 *
	 */
	function onDialogClose(): void {
		setDialogOpen(false)
	}

	/**
	 * Performs onClick prop function
	 *
	 * @param {MouseEvent<HTMLButtonElement>} e
	 */
	function onDialogConfirm(e: MouseEvent<HTMLButtonElement>): void {
		onTitleChange(cacheTitle)
		onDialogClose()
	}

	/**
	 * Performs onClick prop function
	 *
	 * @param {MouseEvent<HTMLButtonElement>} e
	 */
	function onInputChange(e: ChangeEvent<HTMLInputElement>): void {
		setCacheTitle(e.target.value)
	}

	const cls = useCustomTitleStyles()

	/**
	 * Opens the dialog
	 *
	 * @param {MouseEvent<HTMLButtonElement>} e
	 */
	function triggerDialog(e: MouseEvent<HTMLButtonElement>): void {
		e.preventDefault()
		setDialogOpen(true)
	}

	return (
		<>
			<IconEditButton onClick={triggerDialog} />
			<ConfirmDialogue
				open={dialogOpen}
				onClose={onDialogClose}
				onCancel={onDialogClose}
				onConfirm={onDialogConfirm}
			>
				<TextField
					id="canvasTitle"
					name="canvasTitle"
					label="Custom naslov Cash Flow-a"
					variant="outlined"
					value={cacheTitle}
					onChange={onInputChange}
					fullWidth
					className={cls.textField}
					InputLabelProps={{
						htmlFor: "canvasTitle",
					}}
				/>
			</ConfirmDialogue>
		</>
	)
}
